export default __webpack_public_path__ + "static/media/corrections-s1.58abf367.png";